import { type TextFieldProps } from '@mui/material'
import { useMemo } from 'react'
import { useRecurrenceDispatch } from '../../../../../providers/StateProvider'
import { useTexts } from './useTexts'

export function useRecurrenceEndOccurrenceProps(value: number) {
  const dispatch = useRecurrenceDispatch()
  const texts = useTexts()

  return useMemo<TextFieldProps>(
    () => ({
      label: texts.info(value),
      value,
      type: 'number',
      inputProps: { min: 1 },
      sx: { height: 40, mt: '5px' },
      onChange: event => {
        const numOfRecurrencesRequired = Number(event.target.value)
        dispatch({
          type: 'recurrenceEnd:change',
          recurrenceEnd: {
            endType: 'AFTER_NUMBER',
            numOfRecurrencesRequired,
          },
        })
      },
      'data-testid': 'RecurrenceEndOccurrence',
      'data-trackid': 'RecurrenceEndOccurrence',
    }),
    [texts, value, dispatch],
  )
}
